import { Stack } from "@mui/material";
import { sanitizeHtml } from "@src/appV2/Knock/lib/sanitizeHtml";
import { Button } from "@src/appV2/redesign/components/Button";
import { Dialog } from "@src/appV2/redesign/components/Dialog";
import { Text } from "@src/appV2/redesign/components/Text";
import { type UseModalState } from "@src/lib/ui-react";

export interface ReviewPromptGuideViewContent {
  title: string;
  body?: string;
  yesButtonText: string;
  noButtonText: string;
  laterButtonText: string;
}

export interface ReviewPromptGuideViewProps {
  content: ReviewPromptGuideViewContent;
  modalState: UseModalState;
  onYesClick: () => void | Promise<void>;
  onNoClick: () => void | Promise<void>;
  onLaterClick: () => void | Promise<void>;
}

export function ReviewPromptGuideView(props: ReviewPromptGuideViewProps) {
  const { content, modalState, onYesClick, onNoClick, onLaterClick } = props;
  const { title, body, yesButtonText, noButtonText, laterButtonText } = content;

  return (
    <Dialog
      modalState={modalState}
      width={480}
      // Force routing through the three buttons so we always know which path.
      onClose={() => {}}
    >
      <Stack spacing={2}>
        <Text
          semibold
          variant="h5"
          sx={(theme) => ({
            color: theme.palette.base?.strong ?? theme.palette.text.primary,
            wordBreak: "break-word",
            textWrap: "balance",
          })}
        >
          {title}
        </Text>

        {body && (
          <Text
            variant="body2"
            sx={(theme) => ({
              color: theme.palette.base?.base ?? theme.palette.text.secondary,
              wordBreak: "break-word",
            })}
            dangerouslySetInnerHTML={sanitizeHtml({ potentiallyDangerousHtml: body })}
          />
        )}

        <Stack spacing={3} sx={(theme) => ({ paddingTop: theme.spacing(3) })}>
          <Button
            fullWidth
            variant="primary"
            onClick={async () => {
              await onYesClick();
            }}
          >
            {yesButtonText}
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={async () => {
              await onNoClick();
            }}
          >
            {noButtonText}
          </Button>
          <Button
            fullWidth
            variant="link"
            onClick={async () => {
              await onLaterClick();
            }}
          >
            {laterButtonText}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
